export interface NewsSpreadsheetUploadModel {
    clientId: number,
    clipperId: number,    
}

export const newsSpreadsheetUploadDataInitial: NewsSpreadsheetUploadModel = {
    clientId: 0,
    clipperId: 0
};